/* Tikadeau — déplace l'encart .tk-offer juste avant le bouton "Ajouter
   au panier" visible. Nécessaire parce que CustoMeow positionne son
   widget Perso + ATC en JS, donc un bloc statique du template ne peut
   pas se glisser entre les deux. Cette logique runtime règle ça. */
(function () {
  function moveBanner() {
    var banner = document.querySelector('.tk-offer');
    if (!banner) return false;

    // Cherche le bouton ATC visible, en EXCLUANT la sticky-add-to-cart bar
    // (sinon le banner se retrouve coincé dans la barre sticky du bas de page).
    var btns = document.querySelectorAll('button[name="add"], button.add-to-cart-button, button[type="submit"][id*="add-to-cart"]');
    var atc = null;
    for (var i = 0; i < btns.length; i++) {
      // Skip si le bouton est dans la sticky-add-to-cart bar
      if (btns[i].closest('.sticky-add-to-cart, sticky-add-to-cart-component, [class*="sticky-atc"]')) continue;
      var r = btns[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) { atc = btns[i]; break; }
    }
    if (!atc) return false;

    // Trouve le conteneur le plus haut qui groupe l'ATC (le bloc buy-buttons),
    // sinon utilise le bouton lui-même.
    var anchor = atc.closest('[class*="buy-buttons"], [class*="product-form"], .product-information__buy-buttons') || atc;
    if (!anchor.parentNode) return false;

    // N'agit que si le banner n'est pas déjà au bon endroit.
    if (anchor.previousElementSibling === banner) return true;

    anchor.parentNode.insertBefore(banner, anchor);
    return true;
  }

  var tries = 0;
  function attempt() {
    if (moveBanner()) return;
    if (tries++ < 30) setTimeout(attempt, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }

  // Refait le check sur les events de mutation CustoMeow (re-render dynamique).
  if (window.MutationObserver) {
    var obs = new MutationObserver(function () {
      if (!moveBanner()) return;
    });
    obs.observe(document.body, { childList: true, subtree: true });
    // Stop l'observation après 8s pour éviter de tourner indéfiniment.
    setTimeout(function () { obs.disconnect(); }, 8000);
  }
})();
